const emergingThreatsByID = (state) =>
  state.emergingThreats.reduce((obj, val) => {
    obj[val.id] = val;
    return obj;
  }, {});

export const getters = {
  emergingThreatsByID,
};
